module.exports = __webpack_public_path__ + "img/Stapler.b16b0fda.svg";